// src/poker/pokerClock.logic.js
export const LS_KEY = "pokerClock:v1";

export const clampInt = (v, min, max, fallback) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, Math.trunc(n)));
};

export const fmtTime = (sec) => {
  const s = Math.max(0, Math.trunc(sec));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
};

export const money = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return "";
  return new Intl.NumberFormat("pl-PL").format(x);
};

export const buildDefaultLevels = (minutesPerLevel = 12) => {
  const base = [
    [25, 50],
    [50, 100],
    [75, 150],
    [100, 200],
    [150, 300],
    [200, 400],
    [300, 600],
    [400, 800],
    [500, 1000],
    [700, 1400],
    [1000, 2000],
    [1500, 3000],
    [2000, 4000],
    [3000, 6000],
    [4000, 8000],
    [5000, 10000],
  ];
  return base.map(([sb, bb], idx) => ({
    id: `L${idx + 1}`,
    label: `Level ${idx + 1}`,
    minutes: minutesPerLevel,
    sb,
    bb,
    ante: 0,
  }));
};

export const presets = [
  { key: "turbo10", name: "Turbo (10 min)", minutes: 10 },
  { key: "reg12", name: "Regular (12 min)", minutes: 12 },
  { key: "deep15", name: "Deep (15 min)", minutes: 15 },
];

export const calcPrizePool = (settings) => {
  const buyin = Number(settings?.buyin) || 0;
  const players = Number(settings?.players) || 0;
  return Math.max(0, buyin * players);
};

export const calcAvgStack = (settings) => {
  const st = Number(settings?.startingStack) || 0;
  const pl = Number(settings?.players) || 0;
  return pl > 0 ? Math.floor((st * pl) / pl) : 0;
};

export const calcPayoutErrors = (settings, prizePool) => {
  const arr = Array.isArray(settings?.payout) ? settings.payout : [];
  if (!arr.length) return ["Brak payoutu."];

  if (settings?.payoutMode === "percent") {
    const sum = arr.reduce((acc, x) => acc + (Number(x.value) || 0), 0);
    const ok = Math.abs(sum - 100) < 0.001;
    return ok ? [] : [`Suma procentów musi dawać 100% (teraz: ${sum}%).`];
  }

  if (settings?.payoutMode === "amount") {
    const sum = arr.reduce((acc, x) => acc + (Number(x.value) || 0), 0);
    if (sum > prizePool) return [`Suma wypłat > prizepool (${money(sum)} > ${money(prizePool)}).`];
    return [];
  }

  return [];
};
